<template>
  <div class="lms-mss position-relative">
    <div v-if="errorMsg !== null" class="error"> {{ errorMsg }}</div>
    <div class="position-absolute" style="right: 20px; top: 15px; z-index: 100" v-if="isLoading"><img :alt="$t('loading')" :src="loadingUrl"> {{ $t('loading') }} ...</div>
    <div v-if="isDataLoaded">

      <form action="?">
        <label class="w100 fl tr" :for="`selectDate-`+cId">{{ $t('lms.select_time') }}:</label>

        <select class="w150 fl mr-1" :id="`selectDate-`+cId" v-model="selectedDate">
          <option v-for="date in listOfDates" :value="date">{{ date | moment("DD.MM.YYYY HH:mm") }}</option>
        </select>
        <span class="lh-form mr-3 fl">UTC</span>

        <button type="button" :title="$t('prev')"  class="button button-icon-only w50 fl" @click="nextIndex()" :disabled="nextDisabled"><i class="icon-navigate_before"></i></button>
        <button type="button" :title="$t('next')" class="button button-icon-only w50 fl" @click="prevIndex()" :disabled="prevDisabled"><i class="icon-navigate_next"></i></button>

        <button type="button" @click="getData()" :title="$t('refresh_txt')" class="button w75 fl ml-2">{{ $t('lms.refresh') }}</button>
        <div class="clearfix"></div>

      </form>

      <template v-if="selectedContent">

        <div class="content-wrapper">
          <pre v-for="(content, index) in selectedContent" :key="index" v-html="removeHeaderFromContnet(content.body, content.header)">
          </pre>
        </div>


      </template>

    </div>


  </div>
</template>

<script>

import SHMUconf from '../shmu_conf';
import Axios from "axios";

export default {
  components: {
  },
  name: 'LmsMssComponent',
  props: {
    source: {
      type: String,
      default: 'data'
    },
    header_filter: {
      type: String,
      default: ''
    },
    show_header: {
      type: Boolean,
      default: false
    },
    endpoint: String
  },
  data() {
    return {
      latestData: [],
      listOfDates: [],
      listOfForecasts: [],
      loadingUrl: SHMUconf.SITE_BASE_URL + 'img/loader.gif',
      isError: false,
      errorMsg: null,
      isDataLoaded: false,
      isLoading: false,
      selectedDate: null,
      iIndex: null,
      prevDisabled: false,
      nextDisabled: false,
      cId: 0
    }
  },
  watch: {
    selectedDate(v) {

      let currentIndex = this.listOfDates.findIndex(item => item === v);
      let minIndex = 0;
      let maxIndex = this.listOfDates.length - 1;

      if (currentIndex <= minIndex) {
        this.prevDisabled = true;
      } else {
        this.prevDisabled = false;
      }

      if (currentIndex >= maxIndex) {
        this.nextDisabled = true;
      } else {
        this.nextDisabled = false;
      }

    }
  },
  mounted() {
    this.getData();
    this.cId = (((1+Math.random())*0x10000)|0).toString(16).substring(0,4);

  },
  computed: {
    selectedDateIndex() {
      const sDate = this.selectedDate;
      return this.listOfDates.findIndex(item => item === sDate);

    },
    selectedContent() {
      const sDate = this.selectedDate;
      if (sDate) {
        let r = this.latestData.filter(item => item.dt === sDate);
        if (r.length) {
          r.sort((a,b) => (a.header > b.header) ? 1 : ((b.header > a.header) ? -1 : 0))

          return r;
        }
      }
    },



  },
  methods: {
    getData() {
      const self = this;

      self.isLoading = true;
      Axios.get(SHMUconf.API_BASE_URL + 'lms/' + self.endpoint, {
        crossDomain: true,
        cache: false,
      }).then((response) => {
        if (!response.data.error) {

          let rData = response.data[self.source];
          if (self.header_filter !== '') {
            self.latestData = rData.filter(item => item.header.startsWith(self.header_filter));
            //self.latestData = rData;
          } else {
            self.latestData = rData;
          }
          let allDates = [... new Set(self.latestData.map((item) => item.dt))]; // unique
          self.listOfDates =  allDates.sort().reverse();
          if (self.listOfDates.length) {
            self.selectedDate = self.listOfDates[0];
          }

          self.isDataLoaded = true;
          this.isError = false;
          this.errorMsg = null;

        } else {
          this.isError = true;
          if (response.data.error[0].text) {
            this.errorMsg = response.data.error[0].text;
          } else {
            this.errorMsg = 'Nastala chyba pri načítavaní údajov!';
          }
        }
        this.isLoading = false;
      }).catch((error) => {
        this.isError = true;
        this.errorMsg = 'Nastala chyba pri komunikácii so serverom!';
        this.isLoading = false;
      });

    },

    setIndex(index) {
      this.iIndex = index
    },

    prevIndex() {
      if (this.selectedDateIndex > 0) {
        this.selectedDate = this.listOfDates[this.selectedDateIndex - 1];
      }
    },
    nextIndex() {
      if (this.selectedDateIndex < this.listOfDates.length - 1) {
        this.selectedDate = this.listOfDates[this.selectedDateIndex + 1];
      }
    },

    removeHeaderFromContnet(content, header) {
      if (this.show_header) {
        return content;
      }

      return content.replace(header, '').replace('\r\n', '');
    }


  }
}
</script>

<style scoped lang="scss">

</style>
